import React, { Fragment, useState } from "react";
import { Popover, Transition } from "@headlessui/react";
import { XIcon, MenuAlt1Icon } from "@heroicons/react/outline";
import SlideOver from "../../_components/slide_over/SlideOver";
import Menu from "./menu";
import { MenuList } from "./menu_list";

const navigation = [
  { name: "Explore Anthem", href: "https://anthemav.com" },
  { name: "ARC", href: "https://anthemarc.com" },
  { name: "Find a Dealer", href: "https://www.anthemav.com/locator/index.php" },
];
const Header = () => {
  const [showSlideOver, setSlideOver] = useState(false);

  const handleClick = () => {
    setSlideOver(true);
  };

  return (
    <>
      <SlideOver
        open={showSlideOver}
        setOpen={setSlideOver}
        title={"Menu"}
        content={<Menu />}
      />
      <header
        className="top-0 w-full  fixed z-50 shadow-md shadow-red-700/40 "
        style={{ zIndex: 100 }}
      >
        <Popover className="relative bg-black z-50 ">
          <div className="max-w-7xl mx-auto  px-4 md:px-4 lg:px-0">
            <div className="flex flex-row justify-between items-center   py-1 ">
              <div className="-mr-2 -my-2 md:hidden justify-end order-last ">
                <Popover.Button className=" rounded-md p-2 inline-flex items-center justify-center   focus:outline-none focus:ring-2 focus:ring-inset ">
                  <span className="sr-only">Open menu</span>
                  <MenuAlt1Icon
                    className="text-white h-6 w-6 bg-black"
                    aria-hidden="true"
                    onClick={handleClick}
                  />
                </Popover.Button>
              </div>
              <nav className="hidden md:flex space-x-4 pr-0 ml-0 basis-1/3">
                {navigation.map((item, itemIdx) => (
                  <a
                    key={itemIdx}
                    href={item.href}
                    target={"_blank"}
                    className="text-sm font-medium  text-gray-300 hover:text-white  hover:underline underline-offset-[18px] hover:shadow-lg shadow-white"
                  >
                    {item.name}
                  </a>
                ))}
              </nav>
              <div className="flex justify-center lg:w-0 lg:flex-1 basis-1/3">
                <a href="#">
                  <span className="sr-only"></span>
                  <img
                    className="h-8 w-auto sm:h-10"
                    src="https://cdn.pmlsound.com/anthem/avm90/images/anthem-logo-horizontal-wht.svg"
                    alt=""
                  />
                </a>
              </div>
              <div className="hidden md:flex justify-end   md:flex-1 lg:w-0 basis-1/3">
                <MenuAlt1Icon
                  className="text-white h-6 w-6 bg-black cursor-pointer"
                  onClick={handleClick}
                />
              </div>
            </div>
          </div>

          {/* <Transition
            as={Fragment}
            enter="duration-150 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              className="absolute top-0 inset-x-0 p-2 transition transform origin-top md:hidden"
            >
              <div className="rounded-sm shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div className="px-5 pt-4 flex items-center justify-between">
                  <div>
                    <img
                      className="h-8 w-auto"
                      src="https://cdn.pmlsound.com/anthem/avm90/images/anthem-logo-horizontal.svg"
                      alt=""
                    />
                  </div>
                  <div className="-mr-2">
                    <Popover.Button className="rounded-sm p-2 inline-flex items-center justify-center text-gray-700  ">
                      <span className="sr-only">Close menu</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="p-10">
                  <ul className="font-normal text-lg text-gray-900 cursor-pointer">
                    {navigation.map((item) => (
                      <li className="py-3 border-b-2 border-x-gray-700">
                        <a
                          key={item.name}
                          href={item.href}
                          target={"_blank"}
                          className=""
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <MenuList />
                </div>
              </div>
            </Popover.Panel>
          </Transition> */}
        </Popover>
      </header>
    </>
  );
};

export default Header;
